const navItems = [
  { name: "Home", href: "/" },
  { name: "About", href: "about" },
];

module.exports = { navItems };
